const button = "rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-foreground transition-all duration-200";

const iconH4_5W4_5 = "h-4.5 w-4.5";

export { button, iconH4_5W4_5 };
